module.exports = __webpack_public_path__ + "img/benefits-header.2e2235b5.jpg";